import CopilotPanel from "@/components/copilot/CopilotPanel";
import PeriodSelector from "@/components/PeriodSelector";
import PageHeader from "@/components/PageHeader";
import { useI18n } from "@/context/I18nContext";
import { useAuth } from "@/context/AuthContext";
import { AccessDenied, canUseCopilot } from "@/lib/permissions";

export default function CopilotPage() {
  const { lang } = useI18n();
  const { user } = useAuth();
  if (!canUseCopilot(user)) return <AccessDenied testid="copilot-access-denied" />;
  return (
    <div className="p-4 md:p-8 max-w-4xl mx-auto" data-testid="copilot-page">
      <PageHeader
        title={lang === "de" ? "AI Finanzberater" : "AI Finansal Danışman"}
        description={lang === "de"
          ? "Fragen zu deinem Restaurant — Antworten nur aus echten Daten."
          : "Restoranın için gerçek verilerden yanıtlar."}
      />
      <div className="mb-3"><PeriodSelector /></div>
      <div className="border rounded-2xl bg-background overflow-hidden" style={{ height: "78vh" }}>
        <CopilotPanel />
      </div>
    </div>
  );
}
